import React from "react";
import LineIcon from "../../icons/LineIcon";

const TableHeaderCellName = ({ showDivider = true, text }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "5px",
        padding: "10px 0px",
      }}
      data-testid="column-cell-name"
    >
      {showDivider && <LineIcon />}
      {text}
    </div>
  );
};

export default TableHeaderCellName;
